import { WebGLRenderer, Scene } from 'three';
import { Graphics } from './Graphics';
import { Screen } from './Screen';
import { Input } from './Input';
import { SceneManager } from './SceneManager';

const Initializer = {
  init(canvas, container, options = {}) {
    const renderer = new WebGLRenderer({
      canvas,
      antialias: options.antialias || false,
      logarithmicDepthBuffer: options.logarithmicDepthBuffer || false,
      alpha: true,
    });

    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(container.clientWidth, container.clientHeight, false);

    Graphics._renderer = renderer;
    Graphics._container = container;

    Screen._init(canvas);
    Input._init(canvas);

    // Create default scene
    SceneManager.current = new Scene();
  },

  dispose(renderLoop) {
    if (renderLoop) renderLoop.stop();
    if (Graphics._renderer) {
      Graphics._renderer.dispose();
      Graphics._renderer = null;
    }
  },
};

export { Initializer };
